import { render } from "./AboutS2.vue?vue&type=template&id=33f2a4d4&scoped=true"
import script from "./AboutS2.vue?vue&type=script&lang=js"
export * from "./AboutS2.vue?vue&type=script&lang=js"

import "./AboutS2.vue?vue&type=style&index=0&id=33f2a4d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f2a4d4"]])

export default __exports__